export class Forbidden extends Error {
  constructor() {
    super('	Not have permission to do this action');
    this.name = 'Not have permission to do this action';
  }
}
